/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Edit, Mail, Phone, Building2, Shield, Loader2, Save, Check, Star, Send, Award, X, UserPlus, Search, Upload, FileText, Trash2, Eye, Download, Printer, FileCheck, ScrollText, ShieldCheck, Calendar, Hash, MapPin, Globe, Users, Clock } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Badge } from '../ui/badge';
import { toast } from 'sonner';
import axios from 'axios';
import { cn } from '../../lib/utils';
import { formatCodeNAF } from '../../utils/codeNaf';

const API = process.env.REACT_APP_BACKEND_URL;

export const SendFTPEAttestationModal = ({ membre, open, onClose, token }) => {
  const [loading, setLoading] = useState(false);
  const [customEmail, setCustomEmail] = useState('');
  const [useCustomEmail, setUseCustomEmail] = useState(false);

  const handleSend = async () => {
    setLoading(true);
    try {
      const emailTo = useCustomEmail && customEmail ? customEmail : membre.email;
      await axios.post(
        `${API}/api/ftpe-adhesion/send-attestation`,
        { membre_id: membre.id, email: emailTo },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(`Attestation FTPE envoyee a ${emailTo}`);
      onClose();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de l'envoi");
    } finally {
      setLoading(false);
    }
  };

  if (!membre) return null;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Award className="h-5 w-5 text-amber-600" />
            Envoyer l&apos;attestation FTPE
          </DialogTitle>
          <DialogDescription>
            Envoyer l&apos;attestation d&apos;adhesion FTPE a {membre.prenom} {membre.nom}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center">
                <Star className="h-5 w-5 text-amber-600" />
              </div>
              <div>
                <p className="font-medium text-amber-800">Adherent FTPE Outremer</p>
                <p className="text-sm text-amber-600">{membre.entreprise || 'Entreprise'}</p>
              </div>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <input type="checkbox" id="use-custom-email" checked={useCustomEmail} onChange={(e) => setUseCustomEmail(e.target.checked)} className="rounded border-gray-300" />
              <Label htmlFor="use-custom-email" className="text-sm">Envoyer a une autre adresse email</Label>
            </div>
            {useCustomEmail ? (
              <div className="space-y-2">
                <Label htmlFor="custom-email">Email personnalise</Label>
                <Input id="custom-email" type="email" value={customEmail} onChange={(e) => setCustomEmail(e.target.value)} placeholder="autre@email.com" />
              </div>
            ) : (
              <div className="p-3 bg-gray-50 rounded-lg">
                <p className="text-sm text-gray-600">Envoi a : <span className="font-medium">{membre.email}</span></p>
              </div>
            )}
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={loading}>Annuler</Button>
          <Button onClick={handleSend} disabled={loading || (useCustomEmail && !customEmail)} className="bg-amber-500 hover:bg-amber-600">
            {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Send className="h-4 w-4 mr-2" />}
            Envoyer l&apos;attestation
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};


